/* eslint-disable import/no-named-default */
import { combineReducers } from 'redux';
import undoable, { excludeAction } from 'redux-undo';

import { default as nav } from './shared/reducers/nav';
import { default as sidebar } from './shared/reducers/sidebar';
import { default as mobileSideNav } from './shared/reducers/mobile-sidenav';
// import { default as teams } from './components/teams';
import { default as dashboard } from './components/dashboard';
import { default as responses } from './components/responses';
import { default as analytics } from './components/analytics';
import { default as accountManager } from './components/account-manager';
import builderReducer, { defaultState as builderDefaultState } from './components/builder/reducers/builder';
import customiseReducer, { defaultState as customiseDefaultState } from './components/customise/reducers/customise';
import { default as share } from './components/share';
import fieldEditReducer from './components/builder/reducers/fieldSettings';
import { default as imageManager } from './components/image-manager';
import { default as errors } from './components/errors';
import { default as emailReminder } from './components/email-reminder';
import validations from './components/builder/reducers/form-validations';
import { builderActions, customiseActions } from './excluded-actions';
import form from './components/form/reducer/form';
import fileManager from './components/responses/components/file-manager/reducers'
import settings from './components/settings/reducers'
import teams from './components/teams/new-reducers'

export default combineReducers({
  [nav.constants.NAME]: nav.reducers.default,
  [accountManager.constants.NAME]: accountManager.reducers.default,
  // [teams.constants.NAME]: teams.reducers.default,
  [mobileSideNav.constants.NAME]: mobileSideNav.reducers.mobileSidenavReducer,
  [responses.constants.NAME]: responses.reducers.default,
  [sidebar.constants.NAME]: sidebar.reducers.sidebarReducer,
  [dashboard.constants.NAME]: dashboard.reducers.default,
  [analytics.constants.NAME]: analytics.reducers.default,
  [share.constants.NAME]: share.reducers.default,
  builder: undoable(builderReducer, { filter: excludeAction(builderActions), limit: 20 }, builderDefaultState),
  fieldEdit: fieldEditReducer,
  customise: undoable(
    customiseReducer,
    {
      filter: excludeAction(customiseActions),
      limit: 20,
    },
    customiseDefaultState
  ),
  form,
  formValidations: validations,
  [imageManager.constants.NAME]: imageManager.reducers.default,
  [errors.constants.NAME]: errors.reducers.default,
  [emailReminder.constants.NAME]: emailReminder.reducers.default,
  fileManager,
  settings,
  teams,
});
